import * as React from "react";
import { observer } from "mobx-react";
import { InputChoice } from "../Shared";
import { IInputChoiceComponentStatus } from "../States/AreaUiInfo";

export interface IInputChoiseComponentProps {
	model: InputChoice;
	onChange?: () => void;
	uiContext?: IInputChoiceComponentStatus;
	testId?: string;
}

@observer
export class InputChoiseComponent extends React.Component<IInputChoiseComponentProps, {}> {

	handleChange = (event: React.FormEvent<any>) => {
		this.props.model.value = (event.target as any).value as string;
		if (this.props.onChange) {
			this.props.onChange();
		}
		if (this.props.uiContext) {
			this.props.uiContext.inputChoiceComponentStatus.set(this.props.model.label, this.props.model.value);
		}
		this.forceUpdate();
	}

	componentDidMount() {
		if (this.props.uiContext && this.props.uiContext.inputChoiceComponentStatus.has(this.props.model.label)) {
			this.props.model.value = this.props.uiContext.inputChoiceComponentStatus.get(this.props.model.label);
		}
	}

	render() {
		let label = this.props.model.label ? <span>{this.props.model.label}</span> : null;

		return <label>
			{label}
			<div className="custom-select">
				<select
					value={this.props.model.value}
					onChange={this.handleChange}
					disabled={this.props.model.isReadOnly}
					data-test-id={this.props.testId}>
					{this.props.model.values.map(item => {
						return <option key={item.value} value={item.value}>{item.caption}</option>
					})}
				</select>
				{this.props.model.validationMessage ? <span className="is--validation-note">{this.props.model.validationMessage}</span> : null}
			</div>
		</label>;
	}
}

